export enum OnboardingPageName {
  Unknown = "Unknown",
  Landing = "Landing",
  ProgramSelection = "ProgramSelection",
  IdXboxDashboard = "IdXboxDashboard",
  WelcomePartner = "WelcomePartner",
  FormPreview = "FormPreview",
  IntroductionForm = "IntroductionForm",
  GameInformationForm = "GameInformationForm",
}

export enum OnboardingPageAction {
  SelectIdXboxButton = "SelectIdXboxButton",
  SelectPitchButton = "SelectPitchButton",
  ViewIntroductionLink = "ViewIntroductionLink",
  ViewGameConceptLink = "ViewGameConceptLink",
  BecomeAPartnerButton = "BecomeAPartnerButton",
  SwitchAccountLink = "SwitchAccountLink",
  ChangeProgramLink = "ChangeProgramLink",
  GetStartedFormButton = "GetStartedFormButton",
  EditFormButton = "EditFormButton",
  ContinueFormButton = "ContinueFormButton",
  CancelFormButton = "CancelFormButton",
  BackFormButton = "BackFormButton",
  SaveAndNextFormButton = "SaveAndNextFormButton",
  SaveAndExitFormButton = "SaveAndExitFormButton",
  SubmitIntroductionButton = "SubmitIntroductionButton",
  SubmitApplicationButton = "SubmitApplicationButton",
  CreateAccountButton = "CreateAccount",
  SignInButton = "SignInButton",
  ContinueApplicationButton = "ContinueApplicationButton",
  DeleteConceptButton = "DeleteConceptButton",
  NewApplicationLink = "NewApplicationLink",
  SubmitPitchStudioDetailsButton = "SubmitPitchStudioDetailsButton",
  SubmitAaaApplicationButton = "SubmitAaaApplicationButton",
  SubmitPitchApplicationButton = "SubmitPitchApplicationButton",
  ViewPitchConceptLink = "ViewPitchConceptLink",
  PartnerCenterAcceptTermsAndConditionsButton = "PartnerCenterAcceptTermsAndConditionsButton",
  PartnerCenterStartEnrollmentButton = "PartnerCenterStartEnrollmentButton",
  PartnerCenterEditDunsNumberButton = "PartnerCenterEditDunsNumberButton",
  PartnerCenterSendInformationButton = "PartnerCenterSendInformationButton",
  PartnerCenterSelectTypeOfDocumentButton = "PartnerCenterSelectTypeOfDocumentButton",
  PartnerCenterBrowseFileButton = "PartnerCenterBrowseFileButton",
  PartnerCenterRemoveFileButton = "PartnerCenterRemoveFileButton",
  PartnerCenterGoToMicrosoftPartnerCenterButton = "PartnerCenterGoToMicrosoftPartnerCenterButton",
}
